import { Stack } from "PFComponents/containers/flex/stack";
import { fullMarkdown } from "PFCore/helpers/markdown";
import { useMemo } from "react";

import css from "./text_facet.module.scss";

type TextFacetProps = {
  text: string;
};

export const TextFacet = ({ text }: TextFacetProps) => {
  const html = useMemo(() => fullMarkdown(text, { emojify: false }), [text]);

  return (
    <Stack gap="spacingSm" className={css.text} qaId="TextFacet" dangerouslySetInnerHTML={{ __html: html }} />
  );
};
